<template>
  <div>
    <el-dialog
      id="dialogVisitor"
      class="KNS-dialog"
      :visible.sync="dialogVisitorOpen"
      width="80vw"
      center
      @opened="dialogVisitorOpened();"
      @closed="$emit('updateHeaderCount');"
    >
      <span
        slot="title"
        class="dialog-title"
      >
        <div class="title-bar">
          <span class="title">請選擇離開的訪客/廠商</span>
          <span class="subtitle">訪客/廠商拜訪列表</span>
        </div>
        <div
          class="advanced-cog"
          @click="$toPage('communityGuestRecord')"
        >
          <i
            class="icon-list"
            aria-hidden="true"
          />
          訪客紀錄列表
        </div>
      </span>
      <div class="visitorList">
        <el-table
          v-loading="visitorDataLoading"
          class="KNS-Table fordialog"
          :data="visitorData"
          style="width: 100%"
          border
          :row-style="rowStyle"
        >
          <el-table-column
            type="index"
            label="#"
            width="55"
          />
          <el-table-column
            prop="d"
            label="登記時間"
          >
            <template slot-scope="scope">
              <pre>{{ scope.row.d.replace(' ','\n') }}</pre>
            </template>
          </el-table-column>
          <el-table-column
            prop="d"
            label="拜訪時間"
          >
            <template slot-scope="scope">
              {{ returnVisitTime(scope.row.d) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="i"
            label="戶別"
          />
          <el-table-column
            prop="k"
            label="廠商"
            width="120"
          />
          <el-table-column
            prop="j"
            label="訪客"
            width=""
          />
          <el-table-column
            prop="h"
            label="備註"
            width="100"
          >
            <template slot-scope="scope">
              <el-popover
                placement="top"
                trigger="hover"
                popper-class="dark"
              >
                <pre>{{ replaceBr(scope.row.h) }}</pre>
                <el-button
                  slot="reference"
                  @click="showDeatil(scope.row)"
                >
                  查看
                </el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="f"
            label="門禁"
            width="80"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.f != '未使用'">使用中</span>
              <el-popover
                v-if="scope.row.f != '未使用'"
                placement="top-start"
                trigger="hover"
              >
                <pre>有借感應卡</pre>
                <i
                  slot="reference"
                  class="icon-give-card"
                  aria-hidden="true"
                />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button @click="showDeatil(scope.row,true)">
                離開
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      id="dialogVisitorDetail"
      class="KNS-dialog"
      :visible.sync="dialogVisitorDetail"
      width="55%"
      center
    >
      <span
        slot="title"
        class="dialog-title"
      >
        <div class="title-bar">
          <span class="title">訪客詳細相關資訊</span>
        </div>
      </span>
      <div
        v-if="visitorDetail != null"
        class="detail-wrap"
      >
        <span v-if="visitorDetail.peopleCount != undefined">【人數】{{ visitorDetail.peopleCount }}</span>
        <span v-if="visitorDetail.cause != undefined">【事由】{{ visitorDetail.cause }}</span>
        <span v-if="visitorDetail.lend != undefined">【借出】{{ visitorDetail.lend }}</span>
        <span v-if="visitorDetail.mortgage != undefined">【押件】{{ visitorDetail.mortgage }}</span>
        <span v-if="visitorDetail.note != undefined">【備註】{{ visitorDetail.note }}</span>
      </div>
      <div class="fastLeaveLoanChoice">
        <h3>資產借出</h3>
        <el-table
          v-if="exitBtn"
          key="visitorDetail.assetsList"
          v-loading="visitorDetail.assetsListLoading"
          class="KNS-Table fordialog"
          :data="visitorDetail.assetsList"
          style="width: 100%"
          border
          empty-text="目前無符合資料"
        >
          <el-table-column
            type="index"
            label="#"
            width="55"
          />
          <el-table-column
            prop="returnSel"
            label="快選"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.returnSel"
                size="medium"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="displayId"
            label="財產編號"
          />
          <el-table-column
            prop="name"
            label="資產名稱"
          />
          <el-table-column
            prop="quantity"
            label="借出數量"
          />
          <el-table-column
            prop="returnQuantity"
            label="歸還數量"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.returnQuantity"
                @keyup.native="checkReturnQuantity(scope.$index)"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-table
          v-else
          key="visitorDetail.assetsList"
          v-loading="visitorDetail.assetsListLoading"
          class="KNS-Table fordialog"
          :data="visitorDetail.assetsList"
          style="width: 100%"
          border
          empty-text="目前無符合資料"
        >
          <el-table-column
            type="index"
            label="#"
            width="55"
          />
          <el-table-column
            prop="displayId"
            label="財產編號"
          />
          <el-table-column
            prop="name"
            label="資產名稱"
          />
          <el-table-column
            prop="quantity"
            label="借出數量"
          />
        </el-table>
      </div>
      <span
        v-if="exitBtn && !visitorDetail.assetsListLoading"
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          round
          @click="checkOutVisitor"
        >{{ visitorDetail.assetsList.length>0 ? `歸還${countReturn()}項資產，確定離開`:'確定離開' }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      id="dialogNotReturned"
      :visible.sync="dialogNotReturned"
      width="55%"
      center
      :show-close="false"
    >
      <div class="fastLeaveLoanChoice">
        <h3>仍有未歸還物品,確定未歸還離場?</h3>
        <el-table
          class="KNS-Table fordialog"
          :data="notReturnedList()"
          style="width: 100%"
          border
        >
          <el-table-column
            type="index"
            label="#"
          />
          <el-table-column
            prop="displayId"
            label="財產編號"
          />
          <el-table-column
            prop="name"
            label="資產名稱"
          />
          <el-table-column
            prop="quantity"
            label="借出數量"
          />
          <el-table-column
            prop="returnQuantity"
            label="未歸還數量"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.returnSel ? scope.row.quantity - scope.row.returnQuantity:scope.row.quantity }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type=""
          round
          @click="dialogNotReturned = false"
        >取消</el-button>
        <el-button
          type="primary"
          round
          @click="assetsVisitorEndformalities()"
        >確認</el-button>
      </span>
    </el-dialog>

    <el-dialog
      id="dialogVisitorFastLeave"
      class="KNS-dialog"
      :visible.sync="dialogVisitorFastLeave"
      width="55%"
      center
    >
      <span
        slot="title"
        class="dialog-title"
      >
        <div class="title-bar">
          <span class="title">訪客離開</span>
          <span class="subtitle">請選擇訪客離開方式</span>
        </div>
        <div
          class="advanced-cog"
          @click="$toPage('communityGuestRecord')"
        >
          <i
            class="icon-list"
            aria-hidden="true"
          />
          訪客紀錄列表
        </div>
      </span>
      <div class="way-select">
        <ul>
          <li @click="fcnLeave">
            <h3>門禁卡離開</h3>
            <span>訪客持有門禁卡</span>
          </li>
          <li @click="dialogVisitorSwitch()">
            <h3>一般離開</h3>
            <span>訪客無門禁卡</span>
          </li>
        </ul>
      </div>
    </el-dialog>
    <reader ref="reader" />
  </div>
</template>

<script>
import ReadNFCBarcode from '@/components/ReadNFCBarcode'
export default {
  components: {
    reader: ReadNFCBarcode
  },
  data () {
    return {
      dialogVisitorOpen: false,
      dialogVisitorDetail: false,
      dialogNotReturned: false,
      dialogVisitorFastLeave: false,
      visitorDataLoading: true,
      visitorData: [],
      visitorDetail: {
        assetsList: [],
        assetsListLoading: true
      },
      exitBtn: false
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    // 顯示訪客頁面
    dialogVisitorSwitch () {
      this.visitorDataLoading = true
      this.visitorData = []
      this.dialogVisitorOpen = !this.dialogVisitorOpen
      this.dialogVisitorFastLeave = false
    },
    // 訪客頁面開啟事件(載入列表)
    dialogVisitorOpened () {
      // this.visitorDataLoading = true
      document.body.style.overflow = 'hidden'
      const url = process.env.NODE_ENV === 'development' ? '/house/comServiceGuestRecord' : `${process.env.VUE_APP_WS_URL}/comServiceGuestRecord`
      let arr = []
      const obj = {}
      obj.g = ''
      obj.tag = ''
      obj.tab = ''
      obj.t = ''
      obj.s = ''
      obj.d = ''
      obj.fastOut = 'y'
      arr = arr.concat(obj)
      const formdata = new FormData()
      formdata.append('condition', JSON.stringify(arr))
      formdata.append('c', '1')
      formdata.append('f', 'f')
      axios(url, {
        method: 'POST',
        data: formdata,
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'cache-control': 'no-cache'
        }
      }).then(res => {
        console.log(JSON.parse(res.data.list))
        this.visitorData = JSON.parse(res.data.list)
        this.visitorDataLoading = false
      }).catch(err => {

      })
    },
    // 顯示訪客詳細資訊
    showDeatil (data, exitBtn = false) {
      this.exitBtn = exitBtn
      this.dialogVisitorDetail = true
      this.visitorDetail = data
      data.h.split('【').forEach(val => {
        // eslint-disable-next-line eqeqeq
        if (val.indexOf('人數】') != -1) {
          this.visitorDetail.peopleCount = val.split('】')[1].replace(';', '')
        // eslint-disable-next-line eqeqeq
        } else if (val.indexOf('事由】') != -1) {
          this.visitorDetail.cause = val.split('】')[1].replace(';', '')
        // eslint-disable-next-line eqeqeq
        } else if (val.indexOf('借出】') != -1) {
          this.visitorDetail.lend = val.split('】')[1].replace(/;/g, ' ')
        // eslint-disable-next-line eqeqeq
        } else if (val.indexOf('押件】') != -1) {
          this.visitorDetail.mortgage = val.split('】')[1].replace(/;/g, ' ')
        // eslint-disable-next-line eqeqeq
        } else if (val.indexOf('備註】') != -1) {
          this.visitorDetail.note = val.split('】')[1].replace(';', '')
        }
      })
      this.visitorDetail.assetsList = []
      this.visitorDetail.assetsListLoading = true
      // 取得訪客借出資產
      this.getAssetsList().then(val => {
        this.visitorDetail.assetsList = val
        this.visitorDetail.assetsListLoading = false
        this.visitorDetail = JSON.parse(JSON.stringify(this.visitorDetail))
        console.log(this.visitorDetail)
      })
    },
    // 取得訪客借出資產
    getAssetsList () {
      return new Promise((resolve, reject) => {
        const url = process.env.NODE_ENV === 'development' ? '/knamvc/asset_loans' : `${process.env.VUE_APP_KNAMVC_URL}/asset_loans`
        const params = {
          'api-version': '1.0',
          stillLoan: true,
          guestId: this.visitorDetail.a
        }
        let returnFlag = {}
        axios(url, {
          method: 'GET',
          params,
          headers: {
            'content-type': 'application/json; charset=utf-8',
            'cache-control': 'no-cache'
          }
        }).then(res => {
          if (res.data.data.length > 0) {
            this.visitorDetail.id = res.data.data[0].id
            const sandData = res.data.data[0].loanHistories.map(val => val.assetId)
            getListDetail(sandData).then(resDetail => {
              returnFlag = resDetail.data.data
              for (let i = 0; i < returnFlag.length; i++) {
                for (let j = 0; j < res.data.data[0].loanHistories.length; j++) {
                  // eslint-disable-next-line eqeqeq
                  if (returnFlag[i].id == res.data.data[0].loanHistories[j].assetId) {
                    returnFlag[i].quantity = parseInt(res.data.data[0].loanHistories[j].quantity)
                    returnFlag[i].returnQuantity = parseInt(res.data.data[0].loanHistories[j].quantity)
                    returnFlag[i].returnSel = true
                  }
                }
              }
              resolve(returnFlag)
            })
          } else {
            resolve([])
          }
        }).catch(err => {
          // reject()
        })

        const getListDetail = (id = []) => {
          return new Promise((resolve, reject) => {
            const url = process.env.NODE_ENV === 'development' ? '/knamvc/assets' : `${process.env.VUE_APP_KNAMVC_URL}/assets`
            let queryId = ''
            id.forEach(val => { queryId += `&ids=${val}` })
            axios(`${url}?api-version=1.0${queryId}&maxCount=100`, {
              method: 'GET',
              headers: {
                'content-type': 'application/json; charset=utf-8',
                'cache-control': 'no-cache'
              }
            }).then(res => {
              resolve(res)
            }).catch(err => {
              // reject()
            })
          })
        }
      })
    },
    // 回傳訪客停留時間
    returnVisitTime (time) {
      const dateNow = new Date()
      const dateBefore = new Date(time)
      const dateComp = dateNow.getTime() - dateBefore.getTime()
      if (dateComp / (24 * 60 * 60 * 1000) < 1) {
        return `${Math.floor(dateComp / (60 * 60 * 1000))}小時`
      } else {
        return `${Math.floor(dateComp / (24 * 60 * 60 * 1000))}天`
      }
    },
    // 計算歸還資產數量
    countReturn () {
      let count = 0
      this.visitorDetail.assetsList.map(val => {
        if (val.returnSel) {
          count += parseInt(val.returnQuantity)
        }
      })
      return count
    },
    // 把<;>轉成/n
    replaceBr (srt) {
      return srt.replace(/;/g, '\n')
    },
    // 歸還數量Input檢查
    checkReturnQuantity (ind) {
      this.visitorDetail.assetsList[ind].returnQuantity = this.visitorDetail.assetsList[ind].returnQuantity.replace(/[^0-9]/g, '')
      if (this.visitorDetail.assetsList[ind].returnQuantity > this.visitorDetail.assetsList[ind].quantity) {
        this.visitorDetail.assetsList[ind].returnQuantity = this.visitorDetail.assetsList[ind].quantity
      } else if (this.visitorDetail.assetsList[ind].returnQuantity < 1) {
        this.visitorDetail.assetsList[ind].returnQuantity = 1
      }
    },
    // 訪客離開按鈕事件
    checkOutVisitor () {
      if (this.visitorDetail.assetsList.length > 0) {
        // 有借出資產
        if (this.notReturnedList().length > 0) {
          // 有資產未歸還，跳提示視窗
          this.dialogNotReturned = true
        } else {
          // 資產以歸還，進入手續
          this.assetsVisitorEndformalities()
        }
      } else {
        // 無借出資產，直接打訪客離開API
        const loading = this.$loading({
          lock: true,
          text: '處理中，請稍候',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.apiLeaveGuest().then(() => {
          loading.close()
          this.dialogVisitorOpen = false
          this.dialogVisitorDetail = false
          this.dialogNotReturned = false
          this.$message({
            message: '訪客離開已成功!',
            type: 'success'
          })
        }).catch(() => {
          loading.close()
          this.dialogVisitorOpen = false
          this.dialogVisitorDetail = false
          this.dialogNotReturned = false
          this.$message.error('訪客離開失敗!!', this.$t('General.PleaseContactUs'))
        })
      }
    },
    // 未歸還資產列表
    notReturnedList () {
      const flag = []
      this.visitorDetail.assetsList.map(val => {
        if (!val.returnSel) {
          flag.push(val)
        } else {
          // eslint-disable-next-line eqeqeq
          if (val.quantity != val.returnQuantity) {
            flag.push(val)
          }
        }
      })
      return flag
    },
    // API歸還資產
    apiReturnAssets () {
      return new Promise((resolve, reject) => {
        const url = process.env.NODE_ENV === 'development' ? '/knamvc/asset_loans' : `${process.env.VUE_APP_KNAMVC_URL}/asset_loans`
        const data = { returnHistories: [] }
        this.visitorDetail.assetsList.map(val => {
          if (val.returnSel) {
            data.returnHistories.push(
              {
                assetId: val.id,
                quantity: val.returnQuantity
              }
            )
          }
        })
        axios(`${url}/${this.visitorDetail.id}/?api-version=1.0`, {
          method: 'POST',
          data,
          headers: {
            'content-type': 'application/json; charset=utf-8',
            'cache-control': 'no-cache'
          }
        }).then(res => {
          resolve()
        }).catch(err => {
          reject(new Error('歸還資產失敗'))
        })
      })
    },
    // API訪客離開
    apiLeaveGuest () {
      return new Promise((resolve, reject) => {
        const url = process.env.NODE_ENV === 'development' ? '/house/leaveGuest' : `${process.env.VUE_APP_WS_URL}/leaveGuest`
        const formdata = new FormData()
        formdata.append('v', this.visitorDetail.a)
        formdata.append('t', 'id')
        axios(url, {
          method: 'POST',
          data: formdata,
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'cache-control': 'no-cache'
          }
        }).then(res => {
          resolve()
        }).catch(err => {
          reject(new Error('訪客離開失敗'))
        })
      })
    },
    // 訪客離開＆歸還資產手續
    assetsVisitorEndformalities () {
      const loading = this.$loading({
        lock: true,
        text: '處理中，請稍候',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 歸還資產
      this.apiReturnAssets().then(() => {
        // 訪客離開
        this.apiLeaveGuest().then(() => {
          loading.close()
          this.dialogVisitorOpen = false
          this.dialogVisitorDetail = false
          this.dialogNotReturned = false
          this.$message({
            message: '訪客離開已成功!',
            type: 'success'
          })
        }).catch(() => {
          loading.close()
          this.dialogVisitorOpen = false
          this.dialogVisitorDetail = false
          this.dialogNotReturned = false
          this.$message.error('訪客離開失敗!!', this.$t('General.PleaseContactUs'))
        })
      }).catch(() => {
        loading.close()
        this.dialogVisitorOpen = false
        this.dialogVisitorDetail = false
        this.dialogNotReturned = false
        this.$message.error('訪客離開失敗!!', this.$t('General.PleaseContactUs'))
      })
    },
    rowStyle (row) {
      const dateNow = new Date()
      const dateBefore = new Date(row.row.d)
      const dateComp = dateNow.getTime() - dateBefore.getTime()
      let bgc = ''
      if (Math.floor(dateComp / (60 * 60 * 1000)) >= 6) {
        bgc = 'background-color: #f2dede'
      } else if (Math.floor(dateComp / (60 * 60 * 1000)) >= 3) {
        bgc = 'background-color: #FFFEEA'
      }
      return bgc
    },
    fastLeave () {
      this.dialogVisitorFastLeave = !this.dialogVisitorFastLeave
    },
    fcnLeave () {
      this.dialogVisitorFastLeave = false
      this.$refs.reader.getCode((code) => {
        const url = process.env.NODE_ENV === 'development' ? '/guest/GetGIdByCarrier' : `${process.env.VUE_APP_MVCGUEST_URL}/GetGIdByCarrier`
        axios(url, {
          method: 'GET',
          params: { carrier: code }
        }).then((res) => {
          this.$refs.reader.close()
          this.showDeatil({
            a: res.data.Data.GId,
            b: res.data.Data.TabletId,
            h: res.data.Data.TabletNote
          }, true)
        }).catch((err) => {
          this.$message({
            message: err.response == null ? '發生錯誤' : err.response.data.ErrorMessage.Description,
            type: 'warning'
          })
          this.$refs.reader.close()
        })
      }, 'NFC')
    }
  }
}
</script>

<style lang="sass" scoped>
  .KNS-dialog
    ::v-deep .el-dialog
      +KNSDialog
      .visitorList
        height: 500px
        overflow: auto
      .dialog-title
        display: flex
        justify-content: space-between
      .advanced-cog
        margin-right: 50px
        padding: 10px 8px 8px
        border-radius: 2px
        font-size: 17px
        font-weight: normal
        background-color: $bgDark3
        background-image: -webkit-linear-gradient(top,$bgDark3,#e5e5e5)
        color: #333
        border: 1px solid rgba(0,0,0,0.1)
        box-shadow: 1px 1px 2px 0px #888
        i
          vertical-align: sub
          font-size: 26px
          padding-right: 5px
        &:hover
          border: 1px solid #c6c6c6
          background-color: #eee
          background-image: -webkit-linear-gradient(top,#dadada,#d9d9d9)
    ::v-deep .el-table
      +KNSDialogTable
      &__body
        tr
          > td
            .icon-give-card
              font-size: 32px
        .warning
          > td
            background-color: #FFFEEA
    .fastLeaveLoanChoice
      h3
        font-size: 24px
        font-weight: bold
        color: #000
        margin: 25px 0 10px 0px
  #dialogVisitorDetail
    .detail-wrap
      span
        display: block
        margin-top: 5px
        margin-left: 4em
        text-indent: -4em
        font-size: 24px
        color: #000
  #dialogNotReturned
    ::v-deep .el-dialog__body
      padding: 0px 25px 0px 25px
    ::v-deep .el-dialog__footer
      padding-top: 20px
    ::v-deep .el-table
      +KNSDialogTable
</style>
